
import * as React from 'react';
import Slider from 'react-slick';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { getAjaxhelper } from 'src/utils';
import { makeid } from 'src/core';
// import { render } from 'react-dom';
export interface ShowRoomDetailProps extends BaseComponentProps {
    roomId: string;
    lang: string;
    roomName: string;
    hendlerRoomDetailClose: () => any;
}
export interface ShowRoomDetailState extends BaseComponentState {
    roomDetail: any;
    requesting: boolean;

}

export class ShowRoomDetail extends BaseComponent<ShowRoomDetailProps, ShowRoomDetailState> {

    constructor(props: ShowRoomDetailProps) {
        super(props);
        this.state = {
            roomDetail: {}, requesting: true
        };
    }

    componentWillMount() {
        // this.showRoomDetail(this.props.room);
        this.getData();
    }

    getData() {
        getAjaxhelper().post("/dynamics/hb-api/room-detail", { lang: this.props.lang, roomid: this.props.roomId }).then(
            d => {

                this.setStateHelper(
                    st => {
                        st.roomDetail = d;
                        st.requesting = false;
                    }
                );
            }).catch(exc => {
                console.log(exc);
            });
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        if (this.state.requesting) {
            return this.renderLoadingPanel();
        }
        // return this.state.roomDetail;
        let settings = {
            dots: false,
            infinite: true,
            speed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            pauseOnHover: true,
        };
        let slide: any[] = [];
        if ((this.state.roomDetail.roomImages)) {
            for (let a of this.state.roomDetail.roomImages) {
                slide.push(
                    (
                        <div style={{}}>
                            <div
                                key={makeid()}
                                style={{ fontSize: 2, width: '100%', height: '35vw', margin: '.25vw auto', backgroundImage: `url("${a}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                https://www.balihotelsandmore.com
                            </div>
                        </div>
                    )
                );

            }
        }  
        let included: any[] = [];
        if (this.state.roomDetail.roomFacilities) {
            let lop = 0;
            for (let r of this.state.roomDetail.roomFacilities) {
                let labelColor = "label label-default";
                if (r.indLogic === "FALSE") {
                    labelColor = "label label-warning";
                }
                let bintang = '*';
                if (r.indFee === "FALSE") {
                    bintang = '';
                }
                let no = '';
                if (r.number) {
                    no = r.number + '';
                }
                if (r.Facility) {
                    let style: any = {float: 'left'};
                    if (lop > 0) {
                        style = {marginLeft: 5, float: 'left'};
                    }
                    if (r.indYesOrNo === "FALSE") {
                        included.push(<label className={labelColor} style={style}>  {r.Facility.description} {bintang} {no}</label>);
                    } else {
                        included.push(<label className={labelColor}  style={style}> <strong>{r.Facility.description} {bintang} {no}</strong> </label>);
                    }
                }
                lop++;
            }
        }
        let isiGeneralFac: any[] = [];
        if (this.state.roomDetail.facilitiesGlobalHotel) { 
            for (let r of this.state.roomDetail.facilitiesGlobalHotel) {
                let icon = <i className="ti-check" />;
                if (r.indLogic === "FALSE") {
                    icon = <i className="ti-close" />;
                }
                let bintang = <span style={{ color: 'FF0000' }}>*</span>;
                if (r.indFee === "FALSE") {
                    bintang = <span/>;
                }
                let no = '';
                if (r.number) {
                    no = r.number + '';
                }
                if (r.Facility) { 
                    if (r.indYesOrNo === "FALSE") {
                        isiGeneralFac.push(<span className="col-md-3 col-sm-4 col-xs-6"> {icon} <i>  {r.Facility.description} {bintang} {no}</i></span>);
                    } else {
                        isiGeneralFac.push(<span className="col-md-3  col-sm-4  col-xs-6"> {icon} {r.Facility.description} {bintang} {no} </span>  );
                    }
                } 
            }
           
        } 
        let genFas = (
            <div>
                {isiGeneralFac}
            </div>
        );
        return (
            <div>
                <button className="btnClose2" onClick={this.props.hendlerRoomDetailClose}><i className="ti-close" /></button>
                <h3>{this.props.roomName}</h3>
                <Slider {...settings}>
                    {slide}
                </Slider> 
                {included}
                <div className='row margin-top-10' />
                <div className="col-md-12 row" ><h4>General Hotel Facilities </h4></div> 
                {genFas}
                <div className="col-md-12" ><hr  style={{ background: "rgb(238, 238, 238)", margin: "10px 0px" }}/></div>

            </div>
        );
    }
     
    private renderLoadingPanel(): JSX.Element {

        return (

            <div className="col-md-12 bg-white" style={{ minHeight: 500, textAlign: "center", paddingTop: '10%' }}>
                <h4>Please Wait</h4>
                <div className='loader' />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/hotels/ShowRoomDetail.tsx